import React, { Component, useEffect, useReducer, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { HashRouter as Router, Route } from 'react-router-dom';
import { i18nIntl, adaptHeightOnWidget, getRemotedbUrl, isNotEmpty, encodeBase64Fake } from '../lib/ep.js';
import * as Social from '../lib/social.js';

import ParticipateForm from '../components/front/ParticipateForm';

import InnerHTML from 'dangerously-set-html-content'

import ActionLink from '../components/builder/ActionLink';
import Input from '../components/builder/Input.js';
import { AlertMessage } from '../components/builder/Message.js';
import Model from '../components/builder/Model.js';
import PhoneField, { singlePhoneWithPrefix } from '../components/builder/PhoneField';
import SaveButton from '../components/builder/SaveButton.js';
import SocialLoginButton from '../components/builder/SocialLoginButton';
import Spinner from '../components/builder/Spinner';

import Autologin from './Autologin';
import VideoEmbed from '../components/front/VideoEmbed';
import LoginReminder from '../components/elements/LoginReminder.js';
import LeveledHTMLText from '../components/front/helpers/LeveledHTMLText.js';
import MyNetworks from '../components/front/MyNetworks.js';

const CodeLoginForm = (props) => {
	const model = props?.model ?? {};
	const change = props?.change ?? null;
	const errors = props?.errors ?? {};
	const submit = props?.submit ?? null;
	const label = (props.promotion?.code_login_label != undefined && props.promotion?.code_login_label != '') ? props.promotion?.code_login_label : "Enter the code";
	const buttonLabel = (isNotEmpty(props.promotion, 'login_button_label')) ? props.promotion?.login_button_label : "Continue";

	useEffect(()=>{//prefield from code param
		const qs = window.location.search;
		const params = new URLSearchParams(qs);
		const customer = params.get("customer");
		if(customer){//exist param with this value
			change('net_id',customer);
		}
	}, []);

	return (
		<article>
			<Model
				model={model}
				change={change}
				errors={errors}
				classname="gui_form_register template_module gui_main_text_color_on_bg"
			>
				<Input
					id="net_id"
					name="net_id"
					/*error_msg_position_class="only_text"*/
				>{label}</Input>
			</Model>

			<div class="template_module mod_align_center register_call_to_action_flex is_react_cta">
				<div class={'finalize_form enter flex_button gui_big_button dis_wo_signin'}>
					<SaveButton
						_fullclass=""
						disabled={false}
						onClick={submit}
					>{buttonLabel}</SaveButton>
				</div>
			</div>
		</article>
	)
};

const verify_sms = (promotion_id, phone, code, cb) => {
	$.post(`/promotions/sms_verification/${promotion_id}`,{phone,code}, (response) => {
		if(cb != undefined) cb(response);
	}, 'JSON');
};

const SmsConfirm = (props) => {
	const [ state, dispatch ] = useReducer((state, action) => {
		switch(action.type) {
			case 'CHANGE':
				return { ...state, [action.k]:action.v };

			default:
				return state;
		}
	}, {
		phone:props.phone,
		code:'',
		error:null,
	});

	const change = (k, v) => {
		dispatch({ type:'CHANGE', k, v });
	};

	const verify = (e, cb) => {
		dispatch({ type:'VALIDATING' });
		verify_sms(props.promotion.id, state.phone, state.code, (response) => {
			cb();

			if(response.status) {
				if(response.url != undefined) {
					window.location.href = response.url;
					return;
				}

				props.success();
				return;
			}
 
			let error_code = { };
			switch(response.reason) {
				case 'invalid_code':
					error_code.code = "The code is not valid";
					break;

				case 'already_verified':
					error_code.code = "The code has been already registered";
					break;
			}

			dispatch({ type:'CHANGE', k:'error', v:error_code });
		});
	};

	const buttonLabel = (isNotEmpty(props.promotion, 'login_button_label')) ? props.promotion?.login_button_label : "Continue";

	return (
		<div class="gui_login_methods">
			<article>
				<Model
					model={state}
					change={change}
					errors={state.error}
					classname="gui_form_register template_module gui_main_text_color_on_bg"
				>
					<Input
						id="code"
						name="code"
						label_props={{
							_class:{ other:'hb_secondaryFont' },
						}}
						//error_msg_position_class="is_floating"
					>Code</Input>
				</Model>

				<div class="template_module mod_align_center is_react_cta">
					<div class="finalize_form enter flex_button gui_big_button hb_secondaryFont">
						<SaveButton
							key={'verify_button'}
							_fullclass=""
							disabled={false}
							onClick={verify}
						>{buttonLabel}</SaveButton>
					</div>
				</div>

				<ActionLink
					_class={{ other:'gui_not_in_top_small hb_secondaryFont' }}
					onClick={props.back}
				>Try with another phone number</ActionLink>
			</article>
		</div>
	)
};

const SmsLoginForm = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ errors, setErrors ] = useState(props?.errors ?? {});

	const [ state, dispatch ] = useReducer((state, action) => {
		switch(action.type) {
			case 'CHANGE':
				return { ...state, [action.k]:action.v };

			default:
				return state;
		}
	}, {
		state:'phone',
		phone:'',
		code:'',
		error:false,
		isValid:false,
	});

	const change = (k, v) => {
		dispatch({ type:'CHANGE', k, v });
	};

	const onValidate = (is_valid) => {
		dispatch({type:'CHANGE',k:'isValid',v:is_valid})
		if(is_valid) {
			delete errors.phone;
			setErrors({...errors});
		}
	};

	const check_logged = (e, cb) => {
		if(state.phone == '') {
			// no prefix nor phone number:
			setErrors({ ...errors, ['phone']:i18n("This field is mandatory") });
			if(cb != undefined) cb();
			return;
		}

		if(state.phone[state.phone.length - 1] == '-') {
			// has prefix, but no phone number (ends with "-"):
			setErrors({ ...errors, ['phone']:i18n("This field is mandatory") });
			if(cb != undefined) cb();
			return;
		}

		if(state.phone[0] == '_') {
			// has phone number, but no prefix (starts with "_"):
			setErrors({ ...errors, ['phone']:i18n("You need to specify a country") });
			if(cb != undefined) cb();
			return;
		}

		if (!state.isValid) {
			setErrors({ ...errors, ['phone']:i18n("Invalid phone number") });
			if(cb != undefined) cb();
			return;
		}

		props.change('net_id', state.phone);
		props.submit(state.phone, cb);
	};

	const label = (isNotEmpty(props.promotion, 'code_login_label')) ? props.promotion?.code_login_label : "Phone number";
	const buttonLabel = (isNotEmpty(props.promotion, 'login_button_label')) ? props.promotion?.login_button_label : "Continue";

	if(props.sms_credit == 0) {
		return (
			<div>
				<AlertMessage icon='knk-information' _class={{ other:'in_top in_bottom mod_align_left' }}>
					<p>{i18n("Login with your phone number is temporarily disabled.")}</p>
				</AlertMessage>
			</div>
		)
	}

	return (
		<article>
			<Model
				model={state}
				change={change}
				errors={errors}
				classname="gui_form_register template_module gui_main_text_color_on_bg"
			>
				<PhoneField
					id="phone"
					name="phone"
					label_props={{
						_class:{ other:'hb_secondaryFont' },
					}}
					min_digits={props.promotion.phone_min_length}
					max_digits={props.promotion.phone_max_length}
					avail_countries={props.promotion.sms_countries}
					preferred_countries={props.promotion?.sms_preferred_countries ?? []}
					onValidate={onValidate}
					//error_msg_position_class="only_text"
				>{label}</PhoneField>
			</Model>

			{(state.error) && (
				<AlertMessage _class={{ other:'in_top mod_align_left' }}>
					<p dangerouslySetInnerHTML={{ __html:state.error }} />
				</AlertMessage>
			)}

			{(props.errors?.net_id != undefined) && (
				<AlertMessage _class={{ other:'in_top mod_align_left' }}>
					<p dangerouslySetInnerHTML={{ __html:props.errors.net_id }} />
				</AlertMessage>
			)}

			<div class="template_module mod_align_center register_call_to_action_flex is_react_cta">
				<div class={'finalize_form enter flex_button gui_big_button dis_wo_signin'}>
					<SaveButton
						_fullclass=""
						disabled={false}
						onClick={check_logged}
					>{buttonLabel}</SaveButton>
				</div>
			</div>
		</article>
	)
};

class LoginRegister extends Component {
	
	constructor(props) {
		super(props);
		this.email = null;
		this.builder = props?.builder ?? false;
		this.promotion = props.promotion.Promotion;
		this.disable_last_name = this.promotion?.disable_last_name ?? false;

		this.onCloseBinded = false;
		this.state = {
			display_email_form:false,
			display_sms_form:false,
			display_code_form:false,
			display_my_networks:false,
			social_loading:false,
			email:props?.defaults?.em ?? '',
			net_id:"",
			errors:{},
			first_name:props?.defaults?.fn ?? '',
			last_name:(this.disable_last_name) ? " " : props?.defaults?.ln ?? '',
			login_id:(props.login_id) ? props.login_id : false,
			login_type:(props.login_type) ? props.login_type : false,
			old_login_id: (props.login_id) ? props.login_id : false,
			method:null,
			validation_pending:props.validation_pending ?? false,
		}
		// this.state.validation_pending = true;
		// this.state.phone = true;

		if(props.country_id != undefined){
			(props.promotion?.CustomField ?? []).filter((cf) => cf.type == '10').map((cf, i) => {
				this.state['cf_'+cf.id] = props.country_id;
			});
		}

		if(props.user != undefined) {
			this.state = {...this.state,...props.user.User}
		}
	}

	componentWillReceiveProps(props) {
		this.promotion = props.promotion.Promotion;
	}

	componentDidMount() {
		adaptHeightOnWidget();
		let params = new URLSearchParams(new URL(window.location.href).search);
		let social = params.get('social');
		if (social == undefined) return;
		this.setState({social_loading:true});
		let url_login = `/utils/social/${social}`;
		
		const new_url_login = ['google','tiktok','linkedin','twitch','facebook'];	
		if(new_url_login.includes(social) && (this.promotion.id > 973371 || window?.is_local))url_login = `/social_login/${social}`;
		
		const cache_id = params.get('sid');
		if(cache_id)url_login += `?sid=${cache_id}`;

		$.get(getRemotedbUrl(url_login), (resp2) => {
			if(resp2.status == 1) {
				this.socialCallback({customResponse:resp2},social);
			} else {
				this.setState({social_loading:false});
			}
		}, 'JSON');
	}

	dispatchEventStep = (step) => {
		if(document == undefined) return;

		/*
		// You can execute JS codes when dynamically changing the view by using this JS snippet example:
		document.addEventListener("step2", function() {
			alert("IN REGISTER FORM");
		});
		*/

		setTimeout(() => {
			document.dispatchEvent(new Event((step != undefined) ? step : 'step1'));
		}, 0);
	}

	setMethod = (m) => {
		this.setState({ method:m });
	}

	socialCallback = (response,social) => {
		if (response.customResponse != undefined) {
			if(response.customResponse != undefined) response = response.customResponse;
			var parts = response.name != undefined ? response.name.split(' ') : [];
			if (parts.length == 4) {
				this.state.first_name = parts[0] + " " + parts[1];
				this.state.last_name = parts[2] + " " + parts[3];
			}
			if (parts.length == 3) {
				this.state.first_name = parts[0];
				this.state.last_name = parts[1] + " " + parts[2];
			}
			if (parts.length == 2) {
				this.state.first_name = parts[0];
				this.state.last_name = parts[1];
			}
			if (parts.length == 1) {
				this.state.first_name = parts[0];
			}

			if (response.first_name != undefined && response.last_name != undefined) {
				this.state.first_name = response.first_name;
				this.state.last_name = response.last_name;
			}
		}

		//We have response and the email
		if(response.id != undefined && response.email != undefined) {
			this.state.email = response.email;
			this.state.net_id = response.id;
			this.state.social = social;
			if(response.username != undefined) this.state.nickname = response.username;
			if(social=='linkedin' || social=='google' || social=='twitch' || social =='facebook' || social == 'oidc') {
				this.state.avatar = response.avatar;
				this.state.full_avatar = response.full_avatar;
			}

			if(social == 'madrid') {
				for(var key in response) {
					if(!key.includes('cf_')) continue;
					this.state[key] = response[key];
				}
				this.state['fanType'] = response['fanType'];
				this.state['fanSubType'] = response['fanSubType'];
			}

			if(response.first_name != undefined) this.state.first_name = response.first_name;
			if(response.last_name != undefined) this.state.last_name = response.last_name;

			let send_obj = {};
			send_obj = {id:response.id,social:social};
			if(response.email)send_obj.email = response.email;
			if(response.fanType)send_obj.fanType = response.fanType;
			if(response.fanSubType)send_obj.fanSubType = response.fanSubType;
			if (response?.slh != undefined) {
				send_obj.slh = response.slh;
			}

			$.post(getRemotedbUrl(`/promotions/login/${this.promotion.id}`), send_obj , (r) => {
				//The promotion needs email validation
				if(r.status == 1 && r.pending == 1 &&  r.registered) {
					this.setState({ validation_pending:true, first_send:false, social_loading:false });
					return;
				}
				
				if(r != undefined && r.registered != false) {
					if(r.url != undefined) {
						window.location.href = r.url;
						return;
					}

					this.goParticipate(r.registered);
					return;
				}
				this.setState({ login_id:((r.id != undefined) ? r.id : true), method:r.method, social_loading:false,fid:r.fid });

				this.dispatchEventStep('step2');
			}, 'JSON');
		}
	}

	change = (k, v) => {
		this.state[k] = v;
		this.setState({ ...this.state });
	}

	login = (social) => {
		Social.login(social, this.props.scope, (response) => {
			this.socialCallback(response,social);
		},this.promotion.id);
	}

	displayEmailLoginLayer(res) {
		if(this.builder) return;

		this.setState({ display_email_form:!this.state.display_email_form });
	}

	displaySmsLoginLayer(res) {
		if(this.builder) return;

		this.setState({ display_sms_form:!this.state.display_sms_form });
	}

	displayCodeLoginLayer(res) {
		if(this.builder) return;

		this.setState({ display_code_form:!this.state.display_code_form });
	}

	callbackLoginEmail(response,cb,cb2) {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		cb2();
		if (response.registered == true && this.promotion?.one_step_login) {
			this.goParticipate(response.registered);
			// this.setState({errors:{...this.state.errors,email:'You have already registered for this promotion.'}});
			// adaptHeightOnWidget();
			return;
		}else 
		if(response.status == 0 && response.reason != undefined && response.url != undefined) {
			window.location.href = response.url;
			return;
		} else	if (response.status == 0 && response.reason != undefined) {
			this.state.errors['email'] = response.message != undefined ? i18n(response.message) : response.reason;
			this.setState({...this.state});
			adaptHeightOnWidget();
			return;
		}

		//The promotion needs email validation
		if(response.status == 1 && response.pending == 1 &&  response.registered) {
			this.setState({ validation_pending:true, tmp:response.lt, first_send:false });
			adaptHeightOnWidget();
			return;
		}
		cb(response,cb2);
	}

	loginMail = (form, cb) => {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		if(this.builder) return;
		$.post(getRemotedbUrl(`/promotions/login/${this.promotion.id}`), {email:form.email}, (r) => {
			
			if (this.promotion?.one_step_login) {
				cb(r);
				return;
			}

			cb();//Para el BOTO
			this.email = form.email;
			this.state.email = form.email;
			
			this.callbackLoginEmail(r, (response,cb) => {
				if(response.registered != false) {
					if(response.url != undefined) {
						window.location.href = response.url;
						return;
					}
	
					if(response.target_page != undefined) {
						switch (response.target_page) {
							case 'claim':
								window.location.href = getRemotedbUrl(`/promotions/claim/${this.promotion.id}/`);
								return;
							case 'claim_user':
								window.location.href = getRemotedbUrl(`/my_prizes/${this.promotion.id}/`);
								return;
						
							default:
								break;
						}
					}
					cb();//Para el BOTO
					this.goParticipate(response.registered,response.target_stage);
					return;
				}
				
				this.setState({ login_id:((r.id != undefined) ? r.id : true), method:r.method,fid:r.fid});

				this.dispatchEventStep('step2');

				adaptHeightOnWidget();
			},cb)

		}, 'JSON');
	}

	loginCode = (e,cb) => {
		if(this.builder) {
			cb();
			return;
		}

		$.post(getRemotedbUrl(`/promotions/login/${this.promotion.id}`), {social:"code_login",id:this.state.net_id}, (r) => {
			cb();
	
			if(r.status == 0 && r.reason != undefined && r.url != undefined) {
				window.location.href = r.url;
				return;
			}

			if(r.status == 0 && r.reason != undefined) {
				const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
				this.state.errors['net_id'] = (r.message != undefined) ? i18n(r.message) : r.reason;
				this.setState({...this.state});
				adaptHeightOnWidget();
				return;
			}

			if(r.registered != false) {
				if(r.url != undefined) {
					window.location.href = r.url;
					return;
				}

				if(r.target_page != undefined) {
					switch (r.target_page) {
						case 'claim':
							window.location.href = getRemotedbUrl(`/promotions/claim/${this.promotion.id}/`);
							return;
					}
				}

				this.goParticipate(r.registered,r.target_stage);
				return;
			}

			this.setState({ login_id:((r.id != undefined) ? r.id : true), method:r.method,net_type:9,errors:{},fid:r.fid});

			this.dispatchEventStep('step2');

			adaptHeightOnWidget();
		}, 'JSON');
	}

	loginSMS = (net_id,cb) => {
		if(this.builder) {
			cb();
			return;
		}

		$.post(getRemotedbUrl(`/promotions/login/${this.promotion.id}`), {social:"sms_login",id:net_id}, (r) => {
			cb();
	
			if(r.status == 0 && r.reason != undefined && r.url != undefined) {
				window.location.href = r.url;
				return;
			}

			if(r.status == 0 && r.reason != undefined) {
				const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

				let error_msg = "";
				switch(r.reason) {
					case 'too_many_validations':
						error_msg = `${i18n("Limit of verification codes sent reached.")}<br />${i18n("Try it in 24 hours.")}`;
						break;
					default:
						error_msg = r.reason;
						break;
				}

				this.state.errors['net_id'] = (r.message != undefined) ? i18n(r.message) : error_msg;

				this.setState({...this.state});
				adaptHeightOnWidget();
				return;
			}
			
			if (r.status == 1 && r.pending == true) {
				this.setState({ validation_pending:true, tmp:r.lt, first_send:true,phone:r?.phone });
				return;
			}

			if(r.registered != false) {
				if(r.url != undefined) {
					window.location.href = r.url;
					return;
				}

				if(r.target_page != undefined) {
					switch (r.target_page) {
						case 'claim':
							window.location.href = getRemotedbUrl(`/promotions/claim/${this.promotion.id}/`);
							return;
					}
				}

				this.goParticipate(r.registered,r.target_stage);
				return;
			}

			this.setState({
				login_id:((r.id != undefined) ? r.id : true),
				method:r.method,
				net_type:8,
				errors:{},
				phone:this.state.net_id,
				fid:r.fid
			});
			adaptHeightOnWidget();
		}, 'JSON');
	}

	goParticipate = (uid, stage_id) => {

		
		window.location.href = getRemotedbUrl(`/promotions/participate/${this.promotion.id}/${(stage_id == undefined) ? '' : stage_id}`);
	}

	oneStepLogin = (form,resetForm,cb) => {
		this.loginMail(form,(login_res)=>{
			this.callbackLoginEmail(login_res, (response,cb2) => {
				form.login_id = response.id ?? "true";
				form.method = response.method;
				form.fid = response.fid;
				this.loginRegister(form,cb2,resetForm);
			},cb)
			return;
		})
	}


	loginWithMyNets = (form,cb,resetForm) => {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const show_my_nets = (this.promotion.my_networks && this.promotion.my_networks.networks_display == "3") ? true : false;
		if(show_my_nets) {
			this.setState({ display_my_networks:true, login_form:form });
			let layer_title = i18n("Follow us");
			if(isNotEmpty(this.promotion.my_networks.sections[0], 'text')) layer_title = this.promotion.my_networks.sections[0].text;

			cb();
			return;
		} 
		
		if (this.promotion?.one_step_login) {
			this.oneStepLogin(form,resetForm,cb);
			// this.loginMail(form,(login_res)=>{
			// 	this.callbackLoginEmail(login_res, (response,cb2) => {
			// 		form.login_id = response.id ?? "true";
			// 		form.method = response.method;
			// 		form.fid = response.fid;
			// 		this.loginRegister(form,cb2,resetForm);
			// 	},cb)
			// 	return;
			// })
			return;
		}

		this.loginRegister(form,cb,resetForm);
		
	}

	goFirstStep = () => {
		this.setState({ validation_pending:false, login_id:false, display_email_form:false, method:null });
	}

	loginRegister = (form, cb,resetForm) => {

		const local_key = encodeBase64Fake({'ip_hash':this.promotion.id},false,(this.promotion.id).slice(-2));
		if (this.builder) {
			if(cb!=undefined)cb();
			return;
		}

		let data = {...form};
		if(this.state.login_id && data['login_id'] == undefined) data.login_id = this.state.login_id;
		if(this.state.net_id) data.net_id = this.state.net_id;
		if(this.state.social) data.social = this.state.social;
		if(this.state.avatar) data.hashtag_avatar = this.state.avatar;
		if(this.state.fid) data.fid = this.state.fid;
		
		if(window.localStorage != undefined){
			const ls = window.localStorage[local_key];
			if(ls)data.storage = ls;
		}

		$.post(getRemotedbUrl(`/promotions/loginregister/${this.promotion.id}`), {_data:encodeBase64Fake(data,true)}, (r) => {
			if(cb != undefined) cb();
			if(r.status) {
				if (r.url != undefined) {
					window.location.href = r.url;
				}
				else {
					if(r.result != undefined)window.localStorage[local_key] = encodeBase64Fake(r.result);
					this.goParticipate(r.id,r.target_stage);
				}

			} else if(r.status == 0 && r.pending) {
				this.setState({ validation_pending:true, tmp:r.lt, first_send:true,phone:r?.phone });
				adaptHeightOnWidget();
			} else if (r.reason == 'validation_pending') {
				window.location.href = getRemotedbUrl(`/p/${this.promotion.id}`);
			} else if(r.reason != undefined && r.url != undefined) {
				window.location.href = r.url;
			} else if (r.reason == 'already_registered') {
				this.setState({errors:{...this.state.errors,email:'Already Registered'}})
			} 
			else {
				this.state.errors = r.errors;

				const pt_fields = this.props.promotion?.CustomField.filter((cf) => cf.type == '9').map(cf=>cf.id);
				if (pt_fields.length > 0) {
					for (var i in pt_fields) {
						const cf_id = 'cf_' + pt_fields[i];
						if (this.state.errors[cf_id] != undefined) {
							window.location.href = `/promotions/not_allowed/${this.promotion.id}/no_valid?error=urlparam`;
							return;
						}
					}
				}

				this.setState({ ...this.state });
				adaptHeightOnWidget();
				if(resetForm != undefined)resetForm();
			}
		}, 'JSON');
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		const in_preview = this.props?.preview ?? false;
		const email_test_mode = this.props?.email_test_mode ?? false;

		const is_multiparticipation = this.promotion?.multi_participation ?? false;
		const not_guest = this.promotion.login_type == undefined || this.promotion.login_type == '1';

		return (
			<Router hashType="noslash">
				<Route path="/" render={(props) => {
					if(this.state.social_loading) {
						return (
							<div class="loading_after_login gui_main_text_color_on_bg">
								<Spinner
									color='rgba(var(--main-color), 1)'
									autotranslate={false}
								>{i18n("Please wait.")}<br />{i18n("You will be automatically redirected.")}</Spinner>
							</div>
						)
					}

					if(this.state.validation_pending && this.state.phone) {
						return (
							<div class="flex_cols pending_registration_msg">
								<div class="flex_col col_2">
									<div class="register_form_flex" style={{width:'100%'}}>
										<LeveledHTMLText
											_class={{ other:'gui_main_text_color_on_bg gui_not_in_bottom_big' }}
										>
											<h1>{i18n("Phone number verification")}</h1>
											<p><FormattedMessage id="We have sent a SMS text message with a verification code to the phone number {phone}" values={{ phone:<strong>{singlePhoneWithPrefix(this.state.net_id)}</strong> }} /></p>
											<p>{i18n("Please insert the code to continue.")}</p>
										</LeveledHTMLText>

										<SmsConfirm
											promotion={this.promotion}
											phone={this.state.net_id}
											success={() => this.goParticipate()}
											back={() => this.goFirstStep()}
										/>
									</div>
								</div>
							</div>
						);
					}

					//Check if the validation is pending
					if(this.state.validation_pending) {
						const display_email_contents = false;
						const first_send = this.state.first_send;

						const title_label = (first_send) ? "Thanks for registering" : "Access link sent";
						let subtitle_label = (first_send) ? "We have sent you an email to {mail} with the link to participate." : "We have sent you again an email to {mail} with the link to participate.";
						
						if(this.promotion.login_type != undefined && parseInt(this.promotion.login_type) == 4) {
							// Guest mode
							subtitle_label = (first_send) ? "We have sent you an email to {mail} with the link to finalize your registration." : "We have sent you again an email to {mail} with the link to finalize your registration.";
						}
						const is_test = this.promotion?.test ?? false;

						return (
							<div class="flex_cols pending_registrazion_msg">
								<div class="flex_col col_2">
									<div class="register_form_flex" style={{ width:'100%' }}>
										<LeveledHTMLText
											_class={{ other:'gui_main_text_color_on_bg' }}
										>
											{(is_test && email_test_mode && email_test_mode != this.state.email) && (
												<AlertMessage
													icon={false}
													_class={{ other:'test_warning in_top mod_align_left' }}
												>
													<p class="gui_force_bold">{i18n("Promotion in test mode", 'uppercase')}</p>

													<p class="gui_not_in_top_small">{this.props.intl.formatMessage({ id:"Emails are only sent to participants when the promotion is active. During the test, all emails are sent to the admin user at {mail}." }, { mail:email_test_mode })}</p>
												</AlertMessage>
											)}

											<h1 class="gui_not_in_bottom_small">{i18n(title_label)}</h1>

											<p><FormattedMessage id={subtitle_label} values={{mail:this.state.email}} /></p>

											<p><strong style={{textDecoration:'underline'}}>{i18n("If you don't receive the email in your inbox within the next few minutes, please review your spam or promotions folder.")}</strong></p>

											{(display_email_contents) && (
												<p>
													<ActionLink
														_href={`/login${this.promotion.id}/?lt=${this.state.tmp}`}
													>Email received</ActionLink>
												</p>
											)}

											{(not_guest) && (
												<p>
													<ActionLink
														_href={`/promotions/logout/${this.promotion.id}`}
													>Try with another email</ActionLink>
												</p>
											)}
										</LeveledHTMLText>
									</div>
								</div>
							</div>
						);
					}

					if((!this.state.login_id || (this.state.login_type == 7 && this.state.method == null)) && !this.promotion?.one_step_login) {
						if(this.promotion.login_type == '2') {
							return (
								<Autologin promotion={this.props.promotion} />
							)
						}

						document.querySelector('.login_page')?.classList.remove('register_page');

						let fields = {
							Promotion:{ need_email:'1',skip_name:'1' },
							CustomFields:[],
						};

						var enabled_social_networks = [];
						if(this.promotion.login_net_fb) {
							enabled_social_networks.push({
								field:'login_net_fb',
								hide_button:(this.promotion.login_net_mail && this.state.display_email_form) ? true : false,
								label:"Continue with Facebook",
								network:'facebook',
								disabled:window?.in_widget ?? false,
								props:{
									_class:{ other:in_preview ? 'gui_withoutEvents' : '' },
								},
							});
						}

						if(this.promotion.login_net_google) {
							enabled_social_networks.push({
								field:'login_net_google',
								hide_button:(this.promotion.login_net_google && this.state.display_email_form) ? true : false,
								label:"Continue with Google",
								network:'google',
								disabled:window?.in_widget ?? false,
								promotion:this.promotion.id,
								props:{
									_class:{ other:in_preview ? 'gui_withoutEvents' : '' },
								},
							});
						}

						if(this.promotion.login_net_linkedin) {
							enabled_social_networks.push({
								field:'login_net_linkedin',
								hide_button:(this.promotion.login_net_linkedin && this.promotion.display_email_form) ? true : false,
								label:"Continue with Linkedin",
								network:'linkedin',
								promotion:this.promotion.id,
								props:{
									_class:{ other:in_preview ? 'gui_withoutEvents' : '' },
								},
							});
						}

						if(this.promotion.login_net_twitch) {
							enabled_social_networks.push({
								field:'login_net_twitch',
								hide_button:(this.promotion.login_net_twitch && this.promotion.display_email_form) ? true : false,
								label:"Continue with Twitch",
								network:'twitch',
								promotion:this.promotion.id,
								props:{
									_class:{ other:in_preview ? 'gui_withoutEvents' : '' },
								},
							});
						}
						if(this.promotion.login_net_tiktok) {
							enabled_social_networks.push({
								field:'login_net_tiktok',
								hide_button:(this.promotion.login_net_tiktok && this.promotion.display_email_form) ? true : false,
								label:"Continue with TikTok",
								network:'tiktok',
								promotion:this.promotion.id,
								props:{
									_class:{ other:in_preview ? 'gui_withoutEvents' : '' },
								},
							});
						}

						if(this.promotion.login_net_madrid) {
							enabled_social_networks.push({
								field:'login_net_madrid',
								hide_button:(this.promotion.login_net_madrid && this.promotion.display_email_form) ? true : false,
								label:"Login with Real Madrid",
								network:'madrid',
								promotion:this.promotion.id
							});
						}

						if(this.promotion.login_net_code && (enabled_social_networks.length > 0 || this.promotion.login_net_mail || this.promotion.login_net_sms)) {
							enabled_social_networks.push({
								field:'login_net_code',
								cb:(r) => { this.displayCodeLoginLayer(r); },
								hide_button:(this.state.display_code_form) ? true : false,
								label:"Continue with code",
								network:'code',
								prevent_login:true,
							});
						}

						if(this.promotion.login_net_sms && (enabled_social_networks.length > 0 || this.promotion.login_net_mail || this.promotion.login_net_code)) {
							enabled_social_networks.push({
								field:'login_net_sms',
								cb:(r) => { this.displaySmsLoginLayer(r); },
								hide_button:(this.state.display_sms_form) ? true : false,
								label:"Continue with phone number",
								network:'sms',
								prevent_login:true,
							});
						}

						if(this.promotion.login_net_mail && (enabled_social_networks.length > 0 || this.promotion.login_net_sms || this.promotion.login_net_code)) {
							enabled_social_networks.push({
								field:'login_net_mail',
								cb:(r) => { this.displayEmailLoginLayer(r); },
								hide_button:(this.state.display_email_form) ? true : false,
								label:"Continue with email",
								network:'email',
								prevent_login:true,
							});
						}
						let sorted_networks = (this.promotion.login_order == undefined) ? enabled_social_networks : [];
						if(this.promotion.login_order != undefined) {
							this.promotion.login_order.map((net) => {
								let n = enabled_social_networks.find((n) => n.field == net);
								if(n) sorted_networks.push(n);
							})
						}
						const buttonLabel = (isNotEmpty(this.promotion, 'login_button_label')) ? this.promotion?.login_button_label : "Continue";
						return (
							<LoginReminder
								participation={this.props.participation}
								promotion={this.promotion}
								is_builder={this.builder}
								vote_candidate={this.props.vote_candidate}
								locale={this.props.locale}
								vars={this.props?.vars ?? {}}
							>
								<ul class="gui_login_methods">
									{(this.state.method == null && sorted_networks.length > 0) && (
										<li class="gui_form_register social_login" style={{width:'100%'}}>
											{(!this.state.display_email_form && !this.state.display_code_form && !this.state.display_sms_form) && (
												<SocialLoginButton
													login={this.login}
													networks={sorted_networks}
												/>
											)}

											{(this.promotion.login_net_mail && this.state.display_email_form) && (
												<div class="email_login_layer">
													<ParticipateForm
														submit_label={buttonLabel}
														errors={this.state.errors}
														form={this.state}
														fields={fields}
														{...this.props}
														disable_last_name={this.disable_last_name}
														onSubmit={this.loginMail}
													/>

													{((this.promotion?.one_step_login ?? false) === false) && (
														<ActionLink
															onClick={() => this.setState({ display_email_form:false, method:null, errors:{} })}
															_class={{in_top:false, other:'gui_not_in_top_tiny'}}
														>Go back</ActionLink>
													)}
												</div>
											)}

											{(this.promotion.login_net_code && this.state.display_code_form) && (
												<div class="code_login_layer">
													<CodeLoginForm
														promotion={this.promotion}
														model={this.state}
														change={(k, v) => this.setState({[k]:v})}
														errors={this.state.errors}
														submit={this.loginCode.bind(this)}
													/>

													<ActionLink
														onClick={() => this.setState({ display_code_form:false, method:null })}
														_class={{in_top:false, other:'gui_not_in_top_tiny'}}
													>Go back</ActionLink>
												</div>
											)}

											{(this.promotion.login_net_sms && this.state.display_sms_form) && (
												<div class="sms_login_layer">
													<SmsLoginForm
														model={this.state}
														sms_credit={this.props.sms_credit}
														promotion={this.promotion}
														change={(k, v) => this.setState({[k]:v})}
														errors={this.state.errors}
														submit={this.loginSMS.bind(this)}
														intl={this.props.intl}
													/>

													{((this.promotion?.one_step_login ?? false) === false) && (
														<ActionLink
															onClick={() => this.setState({ display_sms_form:false, method:null })}
															_class={{in_top:false, other:'gui_not_in_top_tiny'}}
														>Go back</ActionLink>
													)}
												</div>
											)}
										</li>
									)}
		
									{(sorted_networks.length < 1 && this.promotion.login_net_code) && (
										<CodeLoginForm
											model={this.state}
											promotion={this.promotion}
											change={(k, v) => this.setState({[k]:v})}
											errors={this.state.errors}
											submit={this.loginCode.bind(this)}
										/>
									)}

									{(sorted_networks.length < 1 && this.promotion.login_net_sms) && (
										<SmsLoginForm
											model={this.state}
											sms_credit={this.props.sms_credit}
											promotion={this.promotion}
											change={(k, v) => this.setState({[k]:v})}
											errors={this.state.errors}
											submit={this.loginSMS.bind(this)}
										/>
									)}

									{(sorted_networks.length < 1 && this.promotion.login_net_mail) && (
										<ParticipateForm
											submit_label={buttonLabel}
											errors={this.state.errors}
											form={this.state}
											fields={fields}
											{...this.props}
											disable_last_name={this.disable_last_name}
											onSubmit={this.loginMail}
										/>
									)}
								</ul>
							</LoginReminder>
						)
					} else {
						let name_or_nickname = (is_multiparticipation && this.promotion.hide_name) ? { need_nickname:'1', need_name:!this.promotion.hide_name } : { need_name:'1' };

						let fields = {
							Promotion:Object.assign({}, {...this.promotion}/*, name_or_nickname*/),
							CustomFields:(this.props.promotion?.CustomField ?? []).filter((cf) => cf.stage == '0'),
						};

						document.querySelector('.login_page')?.classList.add('register_page');

						const has_image_header = (this.promotion.full_header_image != undefined && this.promotion.full_header_image != "") ? true : false;

						let has_video_header = false;
						if(!has_image_header) {
							if(this.promotion.video_header && this.promotion.video_header.url) has_video_header = this.promotion.video_header;
							if(this.promotion.register_video && this.promotion.register_video.url) has_video_header = this.promotion.register_video;
						}

						const default_form_introduction = `<h1>${i18n("***Register")}</h1><p>${i18n("You only have to do it once.")}</p>`;
						const form_introduction = (isNotEmpty(this.promotion, 'form_introduction')) ? this.promotion.form_introduction : default_form_introduction;
						const submit_label = (this.promotion.custom_labels != undefined && this.promotion.custom_labels.register_button != undefined && this.promotion.custom_labels.register_button != "") ? this.promotion.custom_labels.register_button : null;
						const disableEmail =  this.state.method == 'email' || (this.promotion.login_type == '5' && this.state.email != undefined)
						const hideEmail =  this.promotion?.hide_email_prefill ?? false;
						const is_autologin = (this.promotion.login_type != undefined && this.promotion.login_type == '2');
						return (
							<div class="flex_cols">
								{(this.promotion.code_tracking_form != "") && (
									<InnerHTML html={this.promotion.code_tracking_form} />
								)}

								{(has_image_header || has_video_header) && (
									<div class="flex_col col_1">
										<div class="register_media_flex">
											{(has_image_header) && (
												<img src={this.promotion.full_header_image} style={{maxWidth:'100%'}} />
											)}

											{(has_video_header !== false) && (
												<VideoEmbed
													video_url={has_video_header.url}
													video_thumb={has_video_header.image}
													autoplay={false}
												/>
											)}
										</div>
									</div>
								)}

								<div class="flex_col col_2">
									<LoginReminder
										participation={this.props.participation}
										promotion={this.promotion}
										is_builder={this.builder}
										display_claim_resumee={this.promotion?.one_step_login ?? false}
										vote_candidate={this.props.vote_candidate}
										locale={this.props.locale}
										vars={this.props?.vars ?? {}}
									>
										<LeveledHTMLText
											_class={{ other:'gui_main_text_color_on_bg' }}
										>{form_introduction}</LeveledHTMLText>

										<div class="register_form_flex" style={{width:'100%'}}>
											<div>
												<ParticipateForm
													submit_label={submit_label}
													errors={this.state.errors}
													form={this.state}
													fields={fields}
													method={this.state.method}
													disableEmail={disableEmail}
													hideEmail={hideEmail}
													disable_last_name={this.disable_last_name}
													{...this.props}
													onSubmit={this.loginWithMyNets}
													recaptcha={this.promotion?.recaptcha_validation ?? false}
												/>

												{(!is_autologin && (this.promotion?.one_step_login ?? false) === false) && (
													<ActionLink onClick={() => this.setState({ login_id:false, display_email_form:false, method:null })} _class={{in_top:false, other:'gui_not_in_top_tiny'}}>Go back</ActionLink>
												)}
											</div>
										</div>
									</LoginReminder>
								</div>

								{(this.state.display_my_networks) && (
									<MyNetworks
										promotion={this.promotion}
										close={(button) => {
											this.setState({ display_my_networks:false });
											if(button == 'button') {
												if (this.promotion?.one_step_login) {
													this.oneStepLogin(this.state.login_form,  () => {},()=>{});
													return;
												}
												this.loginRegister(this.state, () => {});
											}
										}}
									/>
								)}
							</div>
						)
					}
				}} />
			</Router>
		)
	}
}

export default injectIntl(LoginRegister);